import axios from 'axios';
import { API_BASE } from '../config';

const authHeaders = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem('token')}`
  }
});

export const getAllTemplates = async () => {
  try{
  const res = await axios.get(`${API_BASE}form-templates`, authHeaders());
  return res.data;
  } catch (err) {
    console.error('خطا در دریافت قالب‌ها:', err);
    return [];
  }
};

export const getTemplateById = async (id) => {
  try{
  const res = await axios.get(`${API_BASE}form-templates/${id}`, authHeaders());
  return res.data;
  } catch (err) {
    console.error('خطا در دریافت قالب با آیدی:', id, err);
    return null;
  }
};
